import { useState, useCallback, useMemo } from 'react';

import { api } from 'app/api';
import { GET_ORGS } from 'app/common/api/requests/food/schools';


/**
 *  Организации использующиеся в списке мест размещения аппаратов
 */

type Item = {
  id: string;
  title: string;
};

type OrgsState = Record<string, Item>;
type AvailableOrgsItems = OrgsState | Array<Item>;

type ApiSchool = {
  id: number | string;
  title: string;
  deleted?: boolean;
};

type OrgsResult = {
  schools?: Record<string, ApiSchool>;
};

const defaultState: OrgsState = {};

export type AvailableOrgs = [AvailableOrgsItems, boolean, () => void | Promise<void>];
export const defaultAvailableOrgs: AvailableOrgs = [defaultState, true, () => { }];

export default function useAvailableOrgs(): AvailableOrgs {
  const [orgs, setOrgs] = useState<OrgsState>(defaultState);
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_ORGS, {
      error: 'Не удалось получить образовательные учереждения',
      params: {
        type: 'school',
      },
    });

    const schools = (res as OrgsResult | null | undefined)?.schools;
    if (schools) {
      const nextOrgs = Object.values(schools)
        .filter(({ deleted }) => !deleted)
        .reduce<OrgsState>((acc, { id, title }) => {
        const orgId = String(id);
        acc[orgId] = { id: orgId, title };
        return acc;
      }, {});

      setOrgs(nextOrgs);
    }
    setLoading(false);
  }, []);

  const res: AvailableOrgs = useMemo(() => [orgs, loading, request], [orgs, loading, request]);
  return res;
}
